import React from 'react';
import { Link } from 'react-router-dom';
import { Box, BoxProps } from '@mui/material';

/** Loyco brand accent (buttons, links) — spec/extraspec_20260520 */
export const LOYCO_BRAND_BG = '#113d51';
export const LOYCO_WORDMARK_SRC = '/images/loyco-wordmark-branded.png';

interface LoycoBrandLinkProps {
  to?: string;
  logoHeight?: number;
  sx?: BoxProps['sx'];
}

/** Loyco wordmark only — no background tint; PNG colors are shown as-is. */
export default function LoycoBrandLink({ to = '/', logoHeight = 40, sx }: LoycoBrandLinkProps) {
  return (
    <Box
      component={Link}
      to={to}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        textDecoration: 'none',
        ...sx,
      }}
    >
      <Box
        component="img"
        src={LOYCO_WORDMARK_SRC}
        alt="Loyco"
        onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
          e.currentTarget.style.display = 'none';
          const parent = e.currentTarget.parentElement;
          if (parent && !parent.querySelector('.logo-text')) {
            const textLogo = document.createElement('span');
            textLogo.className = 'logo-text';
            textLogo.textContent = 'Loyco';
            textLogo.style.cssText = `font-size: 20px; font-weight: 700; color: ${LOYCO_BRAND_BG};`;
            parent.appendChild(textLogo);
          }
        }}
        sx={{
          height: logoHeight,
          width: 'auto',
          display: 'block',
        }}
      />
    </Box>
  );
}
